import type { MarketplaceFulfillmentStatus } from "@nexus/contracts";

import type { OrderScriptRow } from "../types/marketplace.types";
import { scriptHasVideoAwaitingRevision } from "./effective-script-fulfillment";
import { orderLineVideoKey, orderLineVideos } from "./order-line-videos";

export { scriptHasVideoAwaitingRevision };

export function storedDeliverableIds(script: OrderScriptRow): string[] {
  return orderLineVideos(script)
    .map((video) => video.id)
    .filter((id): id is string => id != null);
}

export function requiresVideoSelectionForRevision(script: OrderScriptRow): boolean {
  return storedDeliverableIds(script).length > 1;
}

/**
 * Resolves `deliverableId` for `SENT_FOR_REVISION` API calls.
 * Omits the field for legacy lines; auto-targets the sole stored video.
 */
export function resolveRevisionDeliverableId(
  script: OrderScriptRow,
  videoKey?: string | null,
): string | undefined {
  const storedIds = storedDeliverableIds(script);
  if (storedIds.length === 0) return undefined;
  if (storedIds.length === 1) return storedIds[0];
  if (!videoKey) return undefined;
  const video = orderLineVideos(script).find(
    (row) => orderLineVideoKey(row) === videoKey,
  );
  return video?.id ?? undefined;
}

export function filterRevisionOptionForMultiVideo(
  options: readonly MarketplaceFulfillmentStatus[],
  script: OrderScriptRow,
): MarketplaceFulfillmentStatus[] {
  if (!requiresVideoSelectionForRevision(script)) return [...options];
  return options.filter((status) => status !== "SENT_FOR_REVISION");
}
